var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemUtilities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_menu_item_utilities_svg__clip0)",
    fill: "#ED1B2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.438 5.5a.688.688 0 100-1.375.688.688 0 000 1.375zm2.75-.688a.688.688 0 11-1.376 0 .688.688 0 011.375 0zm1.375.688a.688.688 0 100-1.375.688.688 0 000 1.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 1.375A2.75 2.75 0 000 4.125v13.75a2.75 2.75 0 002.75 2.75h16.5a2.75 2.75 0 002.75-2.75V4.125a2.75 2.75 0 00-2.75-2.75H2.75zm16.5 1.375a1.375 1.375 0 011.375 1.375v2.75H1.375v-2.75A1.375 1.375 0 012.75 2.75h16.5zM1.375 17.875V8.25h5.5v11H2.75a1.375 1.375 0 01-1.375-1.375zM8.25 19.25v-11h12.375v9.625a1.375 1.375 0 01-1.375 1.375h-11z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_menu_item_utilities_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
}

export default SvgIconMenuItemUtilities;